export enum StaffAccessLevels {
  FacilityUser = "Facility User",
  FacilityAdmin = "Facility Admin",
  RegionalAdmin = "Regional Admin",
  OrgAdmin = "Org Admin",
  MaintenanceAdmin = "Maintenance Admin",
  MaintenanceUser = "Maintenance User",
}
